import React from 'react';
import { 
    Box, 
    Typography, 
    Button, 
    Divider, 
    Paper,
    Stack
} from '@mui/material';
import { styled } from '@mui/system';
import COLORS from '../../theme/Colors';
import FONTS_FAMILY from '../../theme/FontsFamily';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LaptopIcon from '@mui/icons-material/Laptop';

const StyledCard = styled(Paper)(({ theme }) => ({
    padding: '1.5rem', // Reduced from 2rem
    borderRadius: '12px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s ease',
    border: '1px solid #E2E8F0',
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 12px 24px rgba(0,0,0,0.08)',
        borderColor: COLORS.tertiary
    }
}));

const Title = styled(Typography)({
    fontFamily: FONTS_FAMILY.bold.title,
    color: '#202A5D',
    fontSize: '1.15rem', // Slightly smaller
    fontWeight: 700,
    marginBottom: '0.75rem', // Reduced from 1rem
    lineHeight: 1.3
});

const Description = styled(Typography)({
    fontFamily: FONTS_FAMILY.regular.body,
    color: '#4A5568',
    fontSize: '0.9rem', // Slightly smaller
    lineHeight: 1.5,
    marginBottom: '1rem', // Reduced from 1.5rem
    flexGrow: 1,
    display: '-webkit-box',
    WebkitLineClamp: 4, // Show max 4 lines
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

const MetaRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#EA361A',
    marginBottom: '4px', // Reduced
    '& svg': {
        fontSize: '16px' // Smaller icons
    }
});

const MetaText = styled(Typography)({
    fontSize: '0.85rem', // Slightly smaller
    fontWeight: 500,
    color: '#4A5568'
});

const ActionButton = styled(Button)(({ variant }) => ({
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 16px', // Reduced from 10px 20px
    fontSize: '0.9rem', // Slightly smaller
    fontFamily: FONTS_FAMILY.regular.body,
    ...(variant === 'outlined' ? {
        borderColor: '#E2E8F0',
        color: '#4A5568',
        '&:hover': {
            backgroundColor: '#F8FAFC',
            borderColor: '#CBD5E1'
        }
    } : {
        backgroundColor: '#202A5D',
        color: 'white',
        '&:hover': {
            backgroundColor: '#151B3D'
        }
    })
}));

function ServiceCatalogCard({ 
    service,
    onViewDetails, 
    onApply
}) {
    const { 
        name, 
        description, 
        time_limit = 'Variable', 
        cost = 'Variable', 
        addresseds = [],
        type_id
    } = service;

    return (
        <StyledCard elevation={0}>
            <Title variant="h5">{name}</Title>
            <Description variant="body2">{description}</Description>
            
            <Stack spacing={1} sx={{ mb: 2 }}>
                <MetaRow>
                    <AccessTimeIcon />
                    <MetaText>{time_limit || 'Variable'}</MetaText>
                </MetaRow>
                <MetaRow>
                    <AttachMoneyIcon />
                    <MetaText>{cost || 'Variable'}</MetaText>
                </MetaRow>
            </Stack>

            <Stack spacing={1.5} sx={{ mt: 'auto' }}>
                <ActionButton 
                    variant="outlined" 
                    fullWidth 
                    onClick={onViewDetails}
                >
                    Ver servicio
                </ActionButton>
                {type_id !== 1 && (
                    <ActionButton 
                        variant="contained" 
                        fullWidth 
                        onClick={onApply}
                        startIcon={<LaptopIcon />}
                    >
                        Solicitar
                    </ActionButton>
                )}
            </Stack>
        </StyledCard>
    );
}

export default ServiceCatalogCard;
